/* eslint-disable*/
import { AxiosResponse } from 'axios';
import { AccountManagementURLParam } from '../constants/constants';
import { APIError } from '../types/types';

const envs = ['local', 'dev', 'qa', 'uat', 'perf', 'training'];

export const sanitizeURL = (url: string): string => {
  if (!url) {
    return '';
  }

  const badURLRegex = RegExp('^((https)|(http)):/{3,}');
  const isBadURL = badURLRegex.test(url);

  if (isBadURL) {
    return 'https://' + url.replace(badURLRegex, '');
  }

  return url;
};

export const getErrorMessage = (response?: AxiosResponse<APIError>) => {
  if (response?.status === 400 && response?.data.errors[0].code) {
    return response?.data.errors[0].message;
  }

  return null;
};

export const getEnvValue = (): string => {
  const path = window.location.href;
  const envFromPath = path.substring(
    path.indexOf('://') + 3,
    path.indexOf('-')
  );
  return envs.includes(envFromPath) ? envFromPath : 'prod';
};
export const separateDay =(actualDate:string|Date)=>{
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    console.log(actualDate,'actualDate'); 
    const today = new Date(actualDate);
    return days[today.getDay()];
    
  }

export const isLandedFromAM = (pathName: string) =>
  pathName.includes(AccountManagementURLParam);

export function parseApiError(err: any) {
  const raw = err?.data?.errors?.[0]?.error;

  let parsed: any = {};
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return { message: raw };
    }
  }

  if (raw && typeof raw === 'object') {
    parsed = raw;
  }
  return {
    message: parsed.message || 'Unknown error',
    ttl: parsed.ttl,
    supportContact: parsed.supportContact,
  };
}

export interface CommitmentLocationState {
  commitmentDate?: string; // "yyyy-MM-dd" e.g. "2026-04-16"
  commitmentTime?: string; // "HH:mm" 24-hour e.g. "16:15"
}

/**
 * Finds an available timeslot matching the commitment time for a given date.
 *
 * @param commitmentDate - Date string in "yyyy-MM-dd" format
 * @param commitmentTime - Time string in "HH:mm" 24-hour format
 * @param timeSlotData - Array of {Date: string, TimeSlots: Array<{startTime, endTime, timeSlot, status}>}
 * @returns Matching slot object or null
 */
export function matchCommitmentToSlot(
  commitmentDate: string | undefined,
  commitmentTime: string | undefined,
  timeSlotData: Array<{ Date: string; TimeSlots: Array<any> }>
): { date: string; slot: any } | null {
  if (!commitmentDate || !commitmentTime || !timeSlotData?.length) {
    return null;
  }

  const dateEntry = timeSlotData.find((entry) => entry.Date === commitmentDate);
  if (!dateEntry) return null;

  const [commitHour, commitMin] = commitmentTime.split(':').map(Number);
  if (isNaN(commitHour) || isNaN(commitMin)) return null;
  const commitMinutes = commitHour * 60 + commitMin;

  const matchingSlot = dateEntry.TimeSlots.find((slot: any) => {
    if (slot.status !== 'Available') return false;
    const [startH, startM] = slot.startTime.split(':').map(Number);
    const [endH, endM] = slot.endTime.split(':').map(Number);
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;
    return commitMinutes >= startMinutes && commitMinutes < endMinutes;
  });

  if (!matchingSlot) return null;
  return { date: commitmentDate, slot: matchingSlot };
}



export const removeAcimaItems = (input) => {
    if (Array.isArray(input)) {
      for (let idx = input.length - 1; idx >= 0; idx--) {
        const one = input[idx];
        if (
          one !== null &&
          one.name !== null &&
          typeof one === 'object' &&
          typeof one.name === 'string' &&
          one.name.toLowerCase().includes('acima')
        ) {
          input.splice(idx, 1);
          continue;
        }
        removeAcimaItems(one);
      }
      return;
    }

    if (input !== null && typeof input === 'object') {
      Object.values(input).forEach((one) => {
        removeAcimaItems(one);
      });
    }
  };

export const updateResponseToHaveStrings = (input) => {
    if (Array.isArray(input)) {
      input.forEach((one) => updateResponseToHaveStrings(one));
      return;
    }

    if (input !== null && typeof input === 'object') {
      Object.keys(input).forEach((key) => {
        if (key.toLowerCase() == 'id' && typeof input[key] === 'number') {
          input[key] = input[key].toString();
        } else {
          updateResponseToHaveStrings(input[key]);
        }
      });
    }
  };
